import './guide-style.css';
import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Context } from '../../../context/global-data-provider';
import { useGetGuide } from '../../../query';
import LoadingInCenter from '../../components/loading/loading-in-center';

function Guide() {
  const { setCurrentRoute, options } = useContext(Context);

  const [guide, guideQuery] = useGetGuide();

  useEffect(() => {
    setCurrentRoute('/rates');
  });

  useEffect(() => {
    import('highlight.js/styles/atom-one-dark-reasonable.css').catch(() => {});
    import('react-quill/dist/quill.snow.css').catch(() => {});
  }, []);

  return (
    <div className="f-grow-1 card p-26p pt-8p border-sm-none mb-lg-2">
      <Helmet>
        <title>{options.title} • راهنمای سایت</title>
      </Helmet>

      <LoadingInCenter show={guideQuery.isLoading} fill={'#555'} width={30} height={30} />

      {guide?.data && (
        <>
          <div className="card-header f-row align-items-center border-none mb-2">
            <h1 className="title-lg">راهنمای سایت</h1>
          </div>

          <div dangerouslySetInnerHTML={{ __html: guide.data }} />
        </>
      )}
    </div>
  );
}

export default Guide;
